/**
 * Referência de volume alto — usado só para mensagem quando a busca completa falha.
 * A tentativa de busca ocorre mesmo acima desse valor.
 */
export const PATIENT_FINDER_APPOINTMENT_SEARCH_MAX_TOTAL = 390;

/**
 * Lançada quando a busca completa falha e o count do período excede o limite de referência.
 * A mensagem é exibida diretamente no dialog de busca de pacientes.
 */
export class AppointmentSearchVolumeTooHighError extends Error {
  readonly total: number;

  constructor(total: number) {
    super(
      `Foram encontradas ${total} consultas no período.` +
        ` Para que o processamento seja mais rápido, reduza o intervalo de datas e tente novamente.`,
    );
    this.name = "AppointmentSearchVolumeTooHighError";
    this.total = total;
  }
}

export function isAppointmentSearchVolumeAboveLimit(total: number): boolean {
  return total > PATIENT_FINDER_APPOINTMENT_SEARCH_MAX_TOTAL;
}
